import React from 'react'
import styled from 'styled-components'
import Wave from './Wave'

const SectionGroup = styled.div`
  background: url(${props => props.image});
  height: 820px;
  background-size: cover;
  display: grid;
  grid-template-rows: 300px auto;
  grid-gap: 20px;
  position: relative;

  @media (max-width: 640px) {
    height: 920px;
  }
`

const SectionLogo = styled.img`
  align-self: end;
  width: 128px;
  margin: 0 auto;
`

const SectionTitleGroup = styled.div`
  display: grid;
  grid-template-columns: 300px auto;
  margin: 0 40px;
  grid-gap: 20px;
  grid-template-rows: auto 100%;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

const SectionTitle = styled.h3`
  color: white;
  font-size: 55px;
  margin: 30px auto;
  line-height: 1.2;
  @media (max-width: 720px) {
    font-size: 40px;
    text-align: center;
  }
`

const SectionText = styled.p`
  color: white;
  @media (max-width: 720px) {
    font-size: 20px !important;
    margin: 0 auto;
  }
  @media (min-width: 721px) and (max-width: 768px) {
    font-size: 25px !important;
  }
  @media (min-width: 1040px) {
    font-size: 30px !important;
  }
`

const WaveBottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: -6px;
`
const WaveTop = styled.div`
  position: absolute;
  width: 100%;
  top: -6px;
  transform: rotate(180deg);
`

const Section = props => (
  <SectionGroup image={props.image}>
    <WaveTop>
      <Wave />
    </WaveTop>
    <WaveBottom>
      <Wave />
    </WaveBottom>
    <SectionLogo src={props.logo} />
    <SectionTitleGroup>
      <SectionTitle>{props.title}</SectionTitle>
      <SectionText>{props.text}</SectionText>
    </SectionTitleGroup>
  </SectionGroup>
)

export default Section
